var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPolkadex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F3F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.891 16.9614V15.0876L15.6805 11.847H13.7471L18.891 16.9614Z",
    fill: "#1C1C26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07715 7.15033V9.02435L8.28756 12.2647H10.221L5.07715 7.15033Z",
    fill: "#1C1C26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76318 5.14911H8.63697L11.8776 8.35953L15.0895 5.14911H17.0475L11.8776 10.293L6.76318 5.14911Z",
    fill: "#1C1C26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07861 18.8052H8.95239L12.1928 15.5948L15.4042 18.8052H17.3622L12.1928 13.6613L7.07861 18.8052Z",
    fill: "#1C1C26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.8597C12.4748 12.8597 12.8597 12.4748 12.8597 12C12.8597 11.5253 12.4748 11.1404 12 11.1404C11.5253 11.1404 11.1404 11.5253 11.1404 12C11.1404 12.4748 11.5253 12.8597 12 12.8597Z",
    fill: "#E6007A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolkadex);
export default __webpack_public_path__ + "static/media/polkadex.a462629385d667f1862b685992dbfa0a.svg";
export { ForwardRef as ReactComponent };